import { keysToSnakeCaseDeep } from '@agro1desenvolvimento/utils-js';
import aqilaApi from './aqila-api';
import { Pluviometro } from '../@types/pluviometro';

export type PluviometroToSave = {
  cdPropriedade: number;
  cdProdutor: number;
  descricao: string;
};

export type FilterPluviometrosType = {
  propriedade?: number;
  status?: string;
};

class Pluviometros {
  private readonly endpoint = 'v1/pluviometros';

  async list(params: FilterPluviometrosType) {
    const { data } = await aqilaApi.get<Pluviometro[]>(this.endpoint, {
      params: keysToSnakeCaseDeep(params),
    });

    return data;
  }

  async find(id: string) {
    const { data } = await aqilaApi.get<Pluviometro>(`${this.endpoint}/${id}`);

    return data;
  }

  async create(record: PluviometroToSave) {
    await aqilaApi.post(
      this.endpoint,
      keysToSnakeCaseDeep({ pluviometro: record }),
    );
  }

  async update(record: PluviometroToSave & { id: string }) {
    await aqilaApi.patch(
      `${this.endpoint}/${record.id}`,
      keysToSnakeCaseDeep({ pluviometro: record }),
    );
  }

  async inactivate(id: string) {
    await aqilaApi.post(`${this.endpoint}/${id}/inactivate`);
  }

  async activate(id: string) {
    await aqilaApi.post(`${this.endpoint}/${id}/activate`);
  }
}

export default new Pluviometros();
